/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  // Same chevron the desktop megamenu uses (snippets/icon-chevron-down.liquid).
  // It draws an UP chevron; the CSS rotates it to point right when collapsed.
  const CHEVRON_SVG =
    '<svg width="10" height="6" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.00011 4.10853L8.41466 4.64901L4.9898 1.48721L1.56494 4.64901L0.979492 4.10853L4.9898 0.40625L9.00011 4.10853Z" fill="currentColor"/></svg>';

  // Language Selector Functionality
  function initLanguageSelector() {
    const languageToggles = document.querySelectorAll("[data-language-toggle]");

    languageToggles.forEach((toggle) => {
      const dropdown = toggle.nextElementSibling;
      const options = dropdown.querySelectorAll("[data-language-value]");

      // Toggle dropdown
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const isOpen = dropdown.classList.contains("is-open");

        // Close all other dropdowns
        document
          .querySelectorAll(".language-selector__dropdown.is-open")
          .forEach((dd) => {
            dd.classList.remove("is-open");
            dd.previousElementSibling.setAttribute("aria-expanded", "false");
          });

        if (!isOpen) {
          dropdown.classList.add("is-open");
          toggle.setAttribute("aria-expanded", "true");
        } else {
          dropdown.classList.remove("is-open");
          toggle.setAttribute("aria-expanded", "false");
        }
      });

      // Handle language selection
      options.forEach((option) => {
        option.addEventListener("click", function (e) {
          e.preventDefault();

          const languageCode = this.getAttribute("data-language-value");
          const currentLanguage = document.querySelector(
            ".language-selector__current",
          );

          // Update the display
          if (currentLanguage) {
            currentLanguage.textContent = languageCode.toUpperCase();
          }

          // Close dropdown
          dropdown.classList.remove("is-open");
          toggle.setAttribute("aria-expanded", "false");

          // Redirect to the new language
          const currentUrl = new URL(window.location);
          currentUrl.pathname = currentUrl.pathname.replace(
            /^\/[a-z]{2}(-[A-Z]{2})?/,
            "",
          );
          currentUrl.pathname = `/${languageCode}${currentUrl.pathname}`;

          window.location.href = currentUrl.toString();
        });
      });
    });

    // Close dropdown when clicking outside (scoped to header)
    const headerElForLang =
      document.querySelector("[data-site-header]") || document;
    headerElForLang.addEventListener("click", function (e) {
      // Never interfere with product forms or variant selection
      const inProductForm = !!(
        e.target.closest("[data-product-form]") ||
        e.target.closest("popout-select") ||
        e.target.closest("[data-popout-option]") ||
        e.target.closest("[data-product]")
      );
      if (inProductForm) return;

      if (!e.target.closest(".language-selector")) {
        document
          .querySelectorAll(".language-selector__dropdown.is-open")
          .forEach((dd) => {
            dd.classList.remove("is-open");
            dd.previousElementSibling.setAttribute("aria-expanded", "false");
          });
      }
    });

    // Close dropdown on escape key (scoped to header)
    headerElForLang.addEventListener("keydown", function (e) {
      // Never interfere with product forms or variant selection
      const inProductForm = !!(
        e.target.closest("[data-product-form]") ||
        e.target.closest("popout-select") ||
        e.target.closest("[data-popout-option]") ||
        e.target.closest("[data-product]")
      );
      if (inProductForm) return;

      if (e.key === "Escape") {
        document
          .querySelectorAll(".language-selector__dropdown.is-open")
          .forEach((dd) => {
            dd.classList.remove("is-open");
            dd.previousElementSibling.setAttribute("aria-expanded", "false");
          });
      }
    });
  }

  // Add CSS for click-toggle functionality and hover menu styling
  const style = document.createElement("style");
  style.textContent = `
    /* Ensure click-toggle items work properly */
    .menu__item[data-click-toggle] .header__dropdown {
      visibility: hidden !important;
      opacity: 0 !important;
      transform: translateY(-10px) !important;
      pointer-events: none !important;
      transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease !important;
    }
    
    .menu__item[data-click-toggle].is-visible .header__dropdown {
      visibility: visible !important;
      opacity: 1 !important;
      transform: translateY(0) !important;
      pointer-events: all !important;
    }
    
    .menu__item[data-click-toggle].is-visible .header__dropdown__wrapper {
      transform: translateY(0) !important;
      opacity: 1 !important;
    }
    
    /* Hover menu styling */
    .header__hover-menu__close,
    .header__hover-menu__search,
    .header__hover-menu__language-toggle {
      background: none;
      border: none;
      color: inherit;
      font: inherit;
      cursor: pointer;
      padding: 8px 12px;
      text-decoration: none;
      transition: opacity 0.2s ease;
    }
    
    .header__hover-menu__close:hover,
    .header__hover-menu__search:hover,
    .header__hover-menu__language-toggle:hover {
      opacity: 0.7;
    }
    
    .header__hover-menu__link {
      color: inherit;
      text-decoration: none;
      padding: 8px 12px;
      transition: opacity 0.2s ease;
    }
    
    .header__hover-menu__link:hover {
      opacity: 0.7;
    }
    
    .header__hover-menu__language {
      display: inline-block;
    }
    
    .header__hover-menu__language-toggle {
      display: flex;
      align-items: center;
      gap: 4px;
    }
    
    /* Mobile Menu Page Navigation */
    .mobile-menu__page {
      width: 100%;
      min-height: 100%;
    }
    
    /* Deliberately in normal flow, NOT position:absolute. showNestedPage()
       swaps display between the main and nested pages, so they are never
       visible together and need no overlay — and an absolutely positioned
       page pinned to top:0/bottom:0 contributes no height to
       .drawer__content-scroll, so a long submenu could not be scrolled. */
    .mobile-menu__page--nested {
      position: relative;
    }
    
    /* Page trigger button styling */
    .mobile-navlink--page-trigger {
      display: flex !important;
      align-items: center;
      justify-content: flex-start;
      width: 100% !important;
      padding: 15px 20px !important;
      background: none !important;
      border: none !important;
      font-size: 16px !important;
      font-weight: 500 !important;
      color: #000 !important;
      text-align: left !important;
      cursor: pointer !important;
      text-decoration: none !important;
      position: relative !important;
      z-index: 10 !important;
      pointer-events: auto !important;
    }
    
    .mobile-menu__back-button {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 8px 10px;
      background: none;
      border: none;
      font-size: 14px;
      color: #000;
      cursor: pointer;
      width: 100%;
      text-align: left;
    }
    
    .mobile-menu__back-arrow {
      display: flex;
    }
    
    .mobile-menu__page-title {
      padding: 8px 10px;
      margin: 0;
      font-size: 24px;
      color: #000;
      text-transform: uppercase;
      letter-spacing: 1px;
      display: none;
    }
    
    .mobile-nav--nested {
      padding: 0;
      margin: 0;
    }
    
    .mobile-nav--nested .mobile-menu__item:last-child {
      border-bottom: none;
    }
    
    /* Vertical rhythm matches the level-1 list: those rows are <button>s, so
       they take the UA's line-height:normal (~26px at 25px) plus 5px padding
       = 36px per row. Level-2 links are <a>s and would inherit
       .mobile-nav's line-height:1.4, so state both explicitly here to land on
       the same 36px pitch. */
    .mobile-nav--nested .mobile-navlink--level-2 {
      padding: 5px 10px;
      line-height: 26px;
      font-weight: 400;
      color: #000;
      text-decoration: none;
      display: block;
      width: 100%;
    }
    
    .mobile-nav--nested .mobile-nav__sub-sublist {
      padding: 0;
      margin: 0;
    }
    
    .mobile-nav--nested .mobile-nav__sub-sublist .mobile-navlink--level-3 {
      padding: 4px 10px;
      font-size: 14px;
      color: #000;
      text-decoration: none;
      display: block;
    }
    
    /* Hide original accordion dropdowns for main menu items */
    .mobile-menu__item--level-1 .mobile-dropdown {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      height: 0 !important;
      overflow: hidden !important;
    }
    
    .mobile-menu__item--level-1 .mobile-nav__trigger--level-1 {
      display: none !important;
    }
    
    /* Make sure mobile menu triggers are clickable */
    [data-mobile-menu-trigger] {
      position: relative !important;
      z-index: 999 !important;
      pointer-events: auto !important;
      cursor: pointer !important;
    }
  `;
  document.head.appendChild(style);

  // Function to reset nested menu to first item (Women)
  function resetNestedMenuToFirst() {
    const mainMenuItems = document.querySelectorAll(
      ".header__menu-item-parent.has-children[data-main-menu-item]",
    );
    const nestedMenuItems = document.querySelectorAll(
      ".header__menu-item-nested-section[data-nested-menu-item]",
    );

    if (mainMenuItems.length === 0) return;

    // Hide all nested items first
    nestedMenuItems.forEach((nestedItem) => {
      nestedItem.style.display = "none";
      nestedItem.classList.remove("nested-item-active");
    });

    // Remove active class from all main items
    mainMenuItems.forEach((item) => {
      item.classList.remove("nested-item-active");
    });

    // Find the first main item (Women - data-main-menu-item="0")
    const firstMainItem = document.querySelector(
      '.header__menu-item-parent.has-children[data-main-menu-item="0"]',
    );

    if (firstMainItem) {
      // Create a mapping to find corresponding nested items
      const menuMapping = new Map();

      mainMenuItems.forEach((mainItem) => {
        const mainTitle = mainItem.getAttribute("data-main-menu-title");
        const correspondingNestedItems = [];

        // Find nested items that belong to this main menu item
        nestedMenuItems.forEach((nestedItem) => {
          const nestedMainTitle = nestedItem.getAttribute(
            "data-main-menu-title",
          );
          const nestedIndex = nestedItem.getAttribute("data-nested-menu-item");

          if (nestedMainTitle === mainTitle && nestedIndex !== "submenu") {
            correspondingNestedItems.push(nestedItem);
          }
        });

        // Include submenu items for all main menu items
        const submenuItems = document.querySelectorAll(
          '.header__menu-item-nested-section[data-nested-menu-item="submenu"]',
        );
        submenuItems.forEach((submenuItem) => {
          correspondingNestedItems.push(submenuItem);
        });

        menuMapping.set(mainItem, correspondingNestedItems);
      });

      // Show first item's nested items
      const firstMainNestedItems = menuMapping.get(firstMainItem);

      if (firstMainNestedItems && firstMainNestedItems.length > 0) {
        firstMainNestedItems.forEach((nestedItem) => {
          nestedItem.style.display = "block";
          nestedItem.classList.add("nested-item-active");
        });
        firstMainItem.classList.add("nested-item-active");
      }
    }
  }

  // Initialize hover menu functionality
  function initHoverMenu() {
    const closeButton = document.querySelector("[data-hover-menu-close]");
    // Scope to the hover menu's own button: a bare [data-search-popdown-toggle]
    // lookup grabs the first match in the DOM, and on mobile (where the hover
    // menu button isn't rendered) that is the nav drawer's SEARCH button —
    // stacking this legacy force-open handler on top of the drawer's own one
    // makes the popdown open and immediately close again.
    const searchButton = document.querySelector(
      ".header__hover-menu__search[data-search-popdown-toggle]",
    );
    const localeToggle = document.querySelector("[data-locale-toggle]");

    // Close button functionality
    if (closeButton) {
      closeButton.addEventListener("click", function () {
        const header = document.querySelector("[data-site-header]");
        if (header) {
          header.classList.remove("site-header--menu-opened");
          document.body.classList.remove("megamenu-opened");
        }
        // Reset nested menu to first item (Women)
        resetNestedMenuToFirst();
      });
    }

    // Search button functionality
    if (searchButton) {
      searchButton.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const searchPopdown = document.querySelector(
          "[data-popdown-in-header]",
        );

        if (searchPopdown) {
          const details = searchPopdown.querySelector("details");

          if (details) {
            details.setAttribute("open", "");
            details.open = true;
            details.classList.add("is-open");

            const toggleEvent = new Event("toggle", { bubbles: true });
            details.dispatchEvent(toggleEvent);

            const searchToggle = searchPopdown.querySelector(
              "[data-popdown-toggle]",
            );
            if (searchToggle) {
              searchToggle.click();
            }

            document.body.classList.add("search-opened");

            setTimeout(() => {
              const searchInput = searchPopdown.querySelector(
                'input[type="search"]',
              );
              if (searchInput) {
                searchInput.focus();
              }
            }, 200);
          }
        }
      });
    }

    // Language toggle functionality
    if (localeToggle) {
      localeToggle.addEventListener("click", function () {
        const languageSelector = document.querySelector(
          ".select-popout--lang [data-popout-toggle]",
        );
        if (languageSelector) {
          languageSelector.click();
        }
      });
    }
  }

  // Initialize hover menu when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHoverMenu);
  } else {
    initHoverMenu();
  }

  // Click-toggle functionality for menu items
  function initClickToggle() {
    const clickToggleItems = document.querySelectorAll("[data-click-toggle]");

    clickToggleItems.forEach((item) => {
      const topLink = item.querySelector("[data-top-link]");

      if (topLink) {
        topLink.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();

          const isVisible = item.classList.contains("is-visible");

          // Close all other click-toggle items
          clickToggleItems.forEach((otherItem) => {
            if (otherItem !== item) {
              otherItem.classList.remove("is-visible");
              otherItem.setAttribute("aria-expanded", "false");
            }
          });

          // Toggle this item
          if (isVisible) {
            item.classList.remove("is-visible");
            item.setAttribute("aria-expanded", "false");
            document.body.classList.remove("megamenu-opened");

            // Find header and remove menu-opened class
            const header = document.querySelector("[data-site-header]");
            if (header) {
              header.classList.remove("site-header--menu-opened");
            }
          } else {
            item.classList.add("is-visible");
            item.setAttribute("aria-expanded", "true");
            document.body.classList.add("megamenu-opened");

            // Find header and add menu-opened class
            const header = document.querySelector("[data-site-header]");
            if (header) {
              header.classList.add("site-header--menu-opened");
            }

            // Reset nested menu to first item
            setTimeout(() => {
              resetNestedMenuToFirst();
            }, 50);
          }
        });
      }
    });

    // Close dropdowns when clicking outside (scoped to header)
    const headerElForClickToggle =
      document.querySelector("[data-site-header]") || document;
    headerElForClickToggle.addEventListener("click", function (e) {
      // Never interfere with product forms or variant selection
      const inProductForm = !!(
        e.target.closest("[data-product-form]") ||
        e.target.closest("popout-select") ||
        e.target.closest("[data-popout-option]") ||
        e.target.closest("[data-product]")
      );
      if (inProductForm) return;

      if (!e.target.closest("[data-click-toggle]")) {
        clickToggleItems.forEach((item) => {
          item.classList.remove("is-visible");
          item.setAttribute("aria-expanded", "false");
        });
        document.body.classList.remove("megamenu-opened");

        const header = document.querySelector("[data-site-header]");
        if (header) {
          header.classList.remove("site-header--menu-opened");
        }
      }
    });

    // Close dropdowns on escape key (scoped to header)
    headerElForClickToggle.addEventListener("keydown", function (e) {
      // Never interfere with product forms or variant selection
      const inProductForm = !!(
        e.target.closest("[data-product-form]") ||
        e.target.closest("popout-select") ||
        e.target.closest("[data-popout-option]") ||
        e.target.closest("[data-product]")
      );
      if (inProductForm) return;

      if (e.key === "Escape") {
        clickToggleItems.forEach((item) => {
          item.classList.remove("is-visible");
          item.setAttribute("aria-expanded", "false");
        });
        document.body.classList.remove("megamenu-opened");

        const header = document.querySelector("[data-site-header]");
        if (header) {
          header.classList.remove("site-header--menu-opened");
        }
      }
    });
  }

  // Initialize click-toggle when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initClickToggle);
  } else {
    initClickToggle();
  }

  // Grandchild (3rd-level) click-to-reveal — mirrors the "Grandchild reveal
  // method" header setting (click/both). Accordion: one submenu heading's
  // grandchildren open at a time within each mega menu.
  function initGrandchildToggle() {
    const toggles = document.querySelectorAll(
      "[data-grandchild-family] > [data-grandchild-toggle]",
    );

    toggles.forEach((toggle) => {
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        // Stop the megamenu's own outside-click/close handlers from firing.
        e.stopPropagation();

        const family = toggle.closest("[data-grandchild-family]");
        if (!family) return;

        const isOpen = family.classList.contains("is-open");

        // Accordion: close any sibling family within the same dropdown.
        // Scope covers both the standard mega menu (nav-item.liquid) and the
        // menu-item block's nested "list" layout (header-menu-item-block.liquid).
        const scope =
          family.closest(
            ".header__grandparent__links, .header__menu-item-nested",
          ) || document;
        scope
          .querySelectorAll("[data-grandchild-family].is-open")
          .forEach((other) => {
            if (other !== family) {
              other.classList.remove("is-open");
              const otherToggle = other.querySelector(
                "[data-grandchild-toggle]",
              );
              if (otherToggle)
                otherToggle.setAttribute("aria-expanded", "false");
            }
          });

        family.classList.toggle("is-open", !isOpen);
        toggle.setAttribute("aria-expanded", isOpen ? "false" : "true");
      });
    });
  }

  // Initialize grandchild toggle when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initGrandchildToggle);
  } else {
    initGrandchildToggle();
  }

  // Nested Menu Click Functionality
  function initNestedMenuClick() {
    const mainMenuItems = document.querySelectorAll(
      ".header__menu-item-parent.has-children[data-main-menu-item]",
    );
    const nestedMenuItems = document.querySelectorAll(
      ".header__menu-item-nested-section[data-nested-menu-item]",
    );

    // Create a mapping between main menu items and their corresponding nested items
    const menuMapping = new Map();

    mainMenuItems.forEach((mainItem) => {
      const mainTitle = mainItem.getAttribute("data-main-menu-title");
      const correspondingNestedItems = [];

      nestedMenuItems.forEach((nestedItem) => {
        const nestedMainTitle = nestedItem.getAttribute("data-main-menu-title");
        const nestedIndex = nestedItem.getAttribute("data-nested-menu-item");

        if (nestedMainTitle === mainTitle && nestedIndex !== "submenu") {
          correspondingNestedItems.push(nestedItem);
        }
      });

      const submenuItems = document.querySelectorAll(
        '.header__menu-item-nested-section[data-nested-menu-item="submenu"]',
      );
      submenuItems.forEach((submenuItem) => {
        correspondingNestedItems.push(submenuItem);
      });

      menuMapping.set(mainItem, correspondingNestedItems);
    });

    // Add click event listeners to main menu items
    mainMenuItems.forEach((mainItem) => {
      const correspondingNestedItems = menuMapping.get(mainItem);

      mainItem.addEventListener("click", function (e) {
        e.preventDefault();

        const isActive = mainItem.classList.contains("nested-item-active");

        // Clicking the already-open item does nothing — keep its submenu showing.
        if (isActive) {
          return;
        }

        // Hide all nested items first
        nestedMenuItems.forEach((nestedItem) => {
          nestedItem.style.display = "none";
          nestedItem.classList.remove("nested-item-active");
        });

        // Remove active class from all main items
        mainMenuItems.forEach((item) => {
          item.classList.remove("nested-item-active");
        });

        // If this item wasn't active, show its nested items
        if (!isActive) {
          correspondingNestedItems.forEach((nestedItem) => {
            nestedItem.style.display = "block";
            nestedItem.classList.add("nested-item-active");
          });
          mainItem.classList.add("nested-item-active");
        }
      });
    });

    // Add click outside to close menu (scoped to header)
    const headerElForNested =
      document.querySelector("[data-site-header]") || document;
    headerElForNested.addEventListener("click", function (e) {
      // Never interfere with product forms or variant selection
      const inProductForm = !!(
        e.target.closest("[data-product-form]") ||
        e.target.closest("popout-select") ||
        e.target.closest("[data-popout-option]") ||
        e.target.closest("[data-product]")
      );
      if (inProductForm) return;

      if (!e.target.closest(".header__menu-item-mega")) {
        resetNestedMenuToFirst();
      }
    });

    // Initialize: hide all nested items by default
    nestedMenuItems.forEach((nestedItem) => {
      nestedItem.style.display = "none";
    });

    // Show the first main menu item's nested items by default
    if (mainMenuItems.length > 0) {
      const firstMainItem = mainMenuItems[0];
      const firstMainNestedItems = menuMapping.get(firstMainItem);

      if (firstMainNestedItems && firstMainNestedItems.length > 0) {
        firstMainNestedItems.forEach((nestedItem) => {
          nestedItem.style.display = "block";
          nestedItem.classList.add("nested-item-active");
        });
        firstMainItem.classList.add("nested-item-active");
      }
    }
  }

  // Initialize nested menu click when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initNestedMenuClick);
  } else {
    initNestedMenuClick();
  }

  // Mobile Menu Page Navigation
  let mobileMenuInitialized = false;

  function initMobileMenuNavigation() {
    if (mobileMenuInitialized) {
      return;
    }

    const mobileMenuDrawer = document.querySelector("[data-drawer-section]");

    if (!mobileMenuDrawer) {
      return;
    }

    const mainMenuPage = document.querySelector(
      '[data-mobile-menu-page="main"]',
    );
    const nestedPagesContainer = document.querySelector(
      "[data-mobile-menu-nested-pages]",
    );

    // If the required elements don't exist, create them
    if (!mainMenuPage || !nestedPagesContainer) {
      const drawerContent = mobileMenuDrawer.querySelector(
        ".drawer__content-scroll",
      );
      if (drawerContent) {
        const existingContent = drawerContent.innerHTML;
        drawerContent.innerHTML = `
          <div class="mobile-menu__page mobile-menu__page--main" data-mobile-menu-page="main">
            ${existingContent}
          </div>
          <div class="mobile-menu__nested-pages" data-mobile-menu-nested-pages>
            <!-- Nested pages will be generated here by JavaScript -->
          </div>
        `;
      }
    }

    // Re-query elements after potential creation
    const finalMainMenuPage = document.querySelector(
      '[data-mobile-menu-page="main"]',
    );
    const finalNestedPagesContainer = document.querySelector(
      "[data-mobile-menu-nested-pages]",
    );
    const finalMenuTriggers = document.querySelectorAll(
      "[data-mobile-menu-trigger]",
    );

    if (!finalMainMenuPage || !finalNestedPagesContainer) {
      return;
    }

    // Create nested pages for each main menu item
    const menuData = new Map();

    finalMenuTriggers.forEach((trigger) => {
      const menuTitle = trigger.getAttribute("data-menu-title");
      const menuHandle = trigger.getAttribute("data-menu-handle");

      if (!menuData.has(menuTitle)) {
        const parentLi = trigger.closest("li");
        if (parentLi) {
          const dropdown = parentLi.querySelector(
            "[data-collapsible-container]",
          );
          if (dropdown) {
            const nestedItems = dropdown.querySelectorAll(
              ".mobile-menu__item--level-2",
            );
            menuData.set(menuTitle, {
              handle: menuHandle,
              title: menuTitle,
              items: Array.from(nestedItems).map((item) => ({
                element: item,
                title:
                  item
                    .querySelector(".mobile-navlink--level-2")
                    ?.textContent?.trim() || "",
                hasSubItems: item.classList.contains(
                  "mobile-menu__item--has-items",
                ),
                subItems: item.querySelectorAll(".mobile-menu__item--level-3")
                  .length,
              })),
            });
          }
        }
      }
    });

    // Generate nested pages
    menuData.forEach((data, menuTitle) => {
      const nestedPage = document.createElement("div");
      nestedPage.className = "mobile-menu__page mobile-menu__page--nested";
      nestedPage.setAttribute("data-mobile-menu-page", menuTitle);
      nestedPage.style.display = "none";

      const backButton = document.createElement("button");
      backButton.className = "mobile-menu__back-button";
      backButton.innerHTML =
        '<span class="mobile-menu__back-arrow"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg></span> BACK';
      backButton.setAttribute("data-mobile-menu-back", "true");

      const pageTitle = document.createElement("div");
      pageTitle.className = "mobile-menu__page-title";
      pageTitle.textContent = data.title.toUpperCase();

      const itemsList = document.createElement("ul");
      itemsList.className = "mobile-nav mobile-nav--nested";

      data.items.forEach((item) => {
        const listItem = document.createElement("li");
        listItem.className = `mobile-menu__item mobile-menu__item--level-2${item.hasSubItems ? " mobile-menu__item--has-items" : ""}`;

        if (item.hasSubItems) {
          const link = document.createElement("a");
          link.href = "#";
          link.className =
            "mobile-navlink mobile-navlink--level-2 mobile-navlink--trigger";
          link.textContent = item.title;

          const trigger = document.createElement("button");
          trigger.type = "button";
          trigger.className =
            "mobile-nav__trigger mobile-nav__trigger--level-2";
          trigger.setAttribute("aria-expanded", "false");
          trigger.innerHTML = `
            <span class="mobile-nav__trigger-icon">${CHEVRON_SVG}</span>
            <span class="fallback-text">See more</span>
          `;

          const dropdown = document.createElement("div");
          dropdown.className = "mobile-dropdown";
          dropdown.style.display = "none";

          const originalSubItems = item.element.querySelectorAll(
            ".mobile-menu__item--level-3",
          );
          if (originalSubItems.length > 0) {
            const subList = document.createElement("ul");
            subList.className = "mobile-nav__sub-sublist";

            originalSubItems.forEach((subItem) => {
              const subLink = subItem.querySelector("a");
              if (subLink) {
                const subListItem = document.createElement("li");
                subListItem.className =
                  "mobile-menu__item mobile-menu__item--level-3";
                subListItem.innerHTML = `<a href="${subLink.href}" class="mobile-navlink mobile-navlink--level-3">${subLink.textContent.trim()}</a>`;
                subList.appendChild(subListItem);
              }
            });

            dropdown.appendChild(subList);
          }

          listItem.appendChild(link);
          listItem.appendChild(trigger);
          listItem.appendChild(dropdown);

          // Toggle dropdown when clicking the text link (match v1 behavior)
          link.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            const isExpanded = trigger.getAttribute("aria-expanded") === "true";
            trigger.setAttribute("aria-expanded", !isExpanded);
            dropdown.style.display = isExpanded ? "none" : "block";
          });

          trigger.addEventListener("click", function (e) {
            e.preventDefault();
            const isExpanded = trigger.getAttribute("aria-expanded") === "true";
            trigger.setAttribute("aria-expanded", !isExpanded);
            dropdown.style.display = isExpanded ? "none" : "block";
          });
        } else {
          const link = item.element.querySelector("a");
          if (link) {
            listItem.innerHTML = `<a href="${link.href}" class="mobile-navlink mobile-navlink--level-2">${item.title}</a>`;
          }
        }

        itemsList.appendChild(listItem);
      });

      nestedPage.appendChild(backButton);
      nestedPage.appendChild(pageTitle);
      nestedPage.appendChild(itemsList);
      finalNestedPagesContainer.appendChild(nestedPage);
    });

    // Add event listeners for menu triggers
    finalMenuTriggers.forEach((trigger) => {
      if (
        trigger.classList.contains("mobile-navlink--page-trigger") &&
        trigger.closest(".mobile-menu__page--main")
      ) {
        trigger.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          const menuTitle = this.getAttribute("data-menu-title");
          if (menuTitle) {
            showNestedPage(menuTitle);
          }
        });
      }
    });

    // Prevent accordion behavior on main menu items
    const accordionTriggers = document.querySelectorAll(
      ".mobile-nav__trigger--level-1",
    );
    accordionTriggers.forEach((trigger) => {
      trigger.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
    });

    // Add event listeners for back buttons (scoped to mobile drawer)
    const drawerScope =
      document.querySelector("#nav-drawer-section") || document;
    drawerScope.addEventListener("click", function (e) {
      // Never interfere with product forms or variant selection
      const inProductForm = !!(
        e.target.closest("[data-product-form]") ||
        e.target.closest("popout-select") ||
        e.target.closest("[data-popout-option]") ||
        e.target.closest("[data-product]")
      );
      if (inProductForm) return;

      if (e.target.closest("[data-mobile-menu-back]")) {
        e.preventDefault();
        e.stopPropagation();
        showMainPage();
      }
    });

    // The pages share one scroller, so a page swap must start at the top.
    function resetMenuScroll() {
      const scroller = drawerScope.querySelector(
        "[data-scrollable-menu-blocks]",
      );
      if (scroller) scroller.scrollTop = 0;
    }

    function showNestedPage(menuTitle) {
      if (finalMainMenuPage) {
        finalMainMenuPage.style.display = "none";
      }

      const allNestedPages = document.querySelectorAll(
        '[data-mobile-menu-page]:not([data-mobile-menu-page="main"])',
      );
      allNestedPages.forEach((page) => {
        page.style.display = "none";
      });

      const nestedPage = document.querySelector(
        `[data-mobile-menu-page="${menuTitle}"]`,
      );
      if (nestedPage) {
        nestedPage.style.display = "block";
      }

      resetMenuScroll();
    }

    function showMainPage() {
      const nestedPages = document.querySelectorAll(
        '[data-mobile-menu-page]:not([data-mobile-menu-page="main"])',
      );
      nestedPages.forEach((page) => {
        page.style.display = "none";
      });

      if (finalMainMenuPage) {
        finalMainMenuPage.style.display = "block";
      }

      resetMenuScroll();
      resetNestedMenuToFirst();
    }

    mobileMenuInitialized = true;
  }

  // Initialize mobile menu on DOM ready as well (not only on drawer open)
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMobileMenuNavigation);
  } else {
    initMobileMenuNavigation();
  }

  // Initialize mobile menu when drawer is opened
  document.addEventListener("theme:drawer:open", function (e) {
    if (e.detail && e.detail.el && e.detail.el.id === "nav-drawer-section") {
      setTimeout(() => {
        initMobileMenuNavigation();
        resetNestedMenuToFirst();
      }, 500);
    }
  });

  // Custom mobile menu close button handler
  function initMobileMenuCloseButton() {
    const closeButton = document.querySelector(
      '.drawer__close-button[aria-controls="nav-drawer-section"]',
    );
    if (closeButton) {
      closeButton.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const mobileMenuDrawer = document.querySelector("#nav-drawer-section");
        if (mobileMenuDrawer) {
          mobileMenuDrawer.classList.remove("is-open");
          mobileMenuDrawer.setAttribute("aria-hidden", "true");

          // cv-h is content-visibility: hidden — adding it here would blank
          // the menu links instantly while the panel is still sliding out.
          // Stock theme.js adds it on transitionend; do the same, with a
          // timeout fallback, and skip it if the drawer reopened meanwhile.
          const hideContent = (event) => {
            if (event && event.target !== mobileMenuDrawer) return;
            mobileMenuDrawer.removeEventListener("transitionend", hideContent);
            clearTimeout(hideContentFallback);
            if (!mobileMenuDrawer.classList.contains("is-open")) {
              mobileMenuDrawer.classList.add("cv-h");
            }
          };
          mobileMenuDrawer.addEventListener("transitionend", hideContent);
          const hideContentFallback = setTimeout(hideContent, 600);

          document.body.classList.remove("js-drawer-open");
          document.body.classList.remove("js-drawer-open--inner");

          const allDrawerToggles = document.querySelectorAll(
            "[data-drawer-toggle]",
          );
          allDrawerToggles.forEach((button) => {
            button.setAttribute("aria-expanded", "false");
          });

          document.dispatchEvent(
            new CustomEvent("theme:drawer:close", { bubbles: true }),
          );
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: true }),
          );
        }
      });
    }
  }

  // Custom mobile menu search button handler
  function initMobileMenuSearchButton() {
    const searchButton = document.querySelector(
      ".drawer__header__search[data-search-popdown-toggle]",
    );
    if (searchButton) {
      searchButton.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        // The open menu covers the header (z-index 9500 on mobile), and the
        // popdown lives inside the header section — close the menu first so
        // the search UI is actually visible.
        closeNavDrawer();

        // Three <search-popdown> instances exist in the header (desktop,
        // desktop-compress, mobile), each display-gated to its own
        // breakpoint/pointer type. Open the one that is actually displayed —
        // the first match in DOM order is a desktop instance whose fixed
        // body positions wrong on small viewports.
        const searchPopdown = [
          ...document.querySelectorAll("[data-popdown-in-header]"),
        ].find((el) => el.offsetWidth || el.offsetHeight);

        if (searchPopdown) {
          const details = searchPopdown.querySelector("details");
          const searchToggle = searchPopdown.querySelector(
            "[data-popdown-toggle]",
          );

          // A single native summary click opens the popdown and lets
          // theme.js run its own open routine (search-opened class, scroll
          // lock). Pre-setting `details.open` before clicking the summary
          // would make that same click toggle it straight back closed.
          if (details && !details.open && searchToggle) {
            searchToggle.click();
          }

          setTimeout(() => {
            const searchInput = searchPopdown.querySelector(
              'input[type="search"]',
            );
            if (searchInput) {
              searchInput.focus();
            }
          }, 300);
        }
      });
    }
  }

  // Initialize mobile menu close button and search button when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMobileMenuCloseButton);
    document.addEventListener("DOMContentLoaded", initMobileMenuSearchButton);
  } else {
    initMobileMenuCloseButton();
    initMobileMenuSearchButton();
  }

  // Re-initialize when sections are loaded/updated
  document.addEventListener("shopify:section:load", initLanguageSelector);
  document.addEventListener("shopify:section:load", initClickToggle);
  document.addEventListener("shopify:section:load", initHoverMenu);
  document.addEventListener("shopify:section:load", initNestedMenuClick);
  document.addEventListener("shopify:section:load", initMobileMenuNavigation);
  document.addEventListener("shopify:section:select", initLanguageSelector);
  document.addEventListener("shopify:section:select", initClickToggle);
  document.addEventListener("shopify:section:select", initHoverMenu);
  document.addEventListener("shopify:section:select", initNestedMenuClick);
  document.addEventListener("shopify:section:select", initMobileMenuNavigation);

  // GSAP Scroll Animations - Optimized and Mobile-Friendly
  let scrollAnimationsInstance = null;
  let resizeTimeout = null;

  // Instagram Feed Animation (scoped, safe, non-blocking)
  function setupInstagramFeedAnimations(sectionEl) {
    try {
      const container =
        (sectionEl instanceof Element
          ? sectionEl.querySelector(
              ".instafeed-new-layout-wrapper, .instafeed-new-layout-container, [data-instagram-feed], .js-instafeed, #instafeed, #insta-feed",
            )
          : null) ||
        document.querySelector(
          ".instafeed-new-layout-wrapper, .instafeed-new-layout-container, [data-instagram-feed], .js-instafeed, #instafeed, #insta-feed",
        );

      if (!container) return;
      if (container.hasAttribute("data-ig-anim-init")) return;
      container.setAttribute("data-ig-anim-init", "true");

      const getItems = () =>
        container.querySelectorAll(
          ".instafeed-new-layout-item:not(.instagram-animated)",
        );

      // One observer per container
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const el = entry.target;
              el.style.opacity = "1";
              el.style.transform = "translateY(0)";
              io.unobserve(el);
            }
          });
        },
        { threshold: 0.1, root: null, rootMargin: "50px 0px -50px 0px" },
      );

      function hydrate() {
        const items = getItems();
        if (!items.length) return;

        const reduceMotion =
          window.matchMedia &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        const isDesktop =
          window.matchMedia && window.matchMedia("(min-width: 1024px)").matches;

        items.forEach((item, i) => {
          item.classList.add("instagram-animated");
          item.style.opacity = "0";
          item.style.transform = "translateY(30px)";
          item.style.willChange = "opacity, transform";
          item.style.backfaceVisibility = "hidden";
          item.style.transformOrigin = "50% 50%";

          if (reduceMotion) {
            item.style.transition = "none";
            item.style.transitionDelay = "0ms";
            // Respect reduced motion: reveal immediately
            item.style.opacity = "1";
            item.style.transform = "translateY(0)";
          } else {
            item.style.transition =
              "opacity 600ms cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 600ms cubic-bezier(0.25, 0.46, 0.45, 0.94)";
            if (isDesktop) {
              // Desktop: animate all at once (no stagger)
              item.style.transitionDelay = "0ms";
            } else {
              // Mobile/tablet: subtle stagger 0–500ms in groups of 6
              const delay = (i % 6) * 100;
              item.style.transitionDelay = `${delay}ms`;
            }
          }

          io.observe(item);

          // If already in viewport, reveal immediately to avoid waiting for IO tick
          const rect = item.getBoundingClientRect();
          const vh =
            window.innerHeight || document.documentElement.clientHeight;
          if (rect.top < vh && rect.bottom > 0) {
            item.style.opacity = "1";
            item.style.transform = "translateY(0)";
          }
        });
      }

      // Initial pass
      hydrate();

      // Observe only within the container
      let debounceId = null;
      const mo = new MutationObserver((mutations) => {
        const relevant = mutations.some((m) =>
          Array.from(m.addedNodes || []).some((n) => {
            if (n.nodeType !== 1) return false;
            return (
              (n.classList &&
                n.classList.contains("instafeed-new-layout-item")) ||
              (n.querySelector && n.querySelector(".instafeed-new-layout-item"))
            );
          }),
        );
        if (!relevant) return;
        clearTimeout(debounceId);
        debounceId = setTimeout(hydrate, 200);
      });

      mo.observe(container, { childList: true, subtree: true });

      // Optional cleanup per container
      container._igAnimCleanup = function () {
        try {
          io.disconnect();
          mo.disconnect();
          clearTimeout(debounceId);
        } catch (e) {}
      };
    } catch (error) {
      console.error("setupInstagramFeedAnimations failed:", error);
    }
  }

  // Initialize Instagram animations for any section containing a feed
  function initInstagramAnimations() {
    const sections = document.querySelectorAll(".shopify-section");
    let initializedAny = false;

    sections.forEach((section) => {
      if (section.querySelector(".instafeed-new-layout-item")) {
        setupInstagramFeedAnimations(section);
        initializedAny = true;
      }
    });

    if (!initializedAny) {
      setupInstagramFeedAnimations();
    }
  }

  // DOM ready init
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initInstagramAnimations);
  } else {
    initInstagramAnimations();
  }

  // Bootstrap when containers are injected after load (e.g., app renders late)
  const IG_CONTAINER_SELECTOR =
    ".instafeed-new-layout-wrapper, .instafeed-new-layout-container, [data-instagram-feed], .js-instafeed, #instafeed, #insta-feed";

  function bootstrapInstagramWhenPresent() {
    const containers = document.querySelectorAll(IG_CONTAINER_SELECTOR);
    containers.forEach((container) => {
      if (container && !container.hasAttribute("data-ig-anim-init")) {
        const section = container.closest(".shopify-section");
        setupInstagramFeedAnimations(section || document);
      }
    });
  }

  let igBootstrapObserver = null;
  function startIgBootstrapObserver() {
    if (igBootstrapObserver) return;
    let debounceId;
    igBootstrapObserver = new MutationObserver((mutations) => {
      let found = false;
      for (const m of mutations) {
        for (const n of m.addedNodes) {
          if (n.nodeType !== 1) continue;
          if (
            (n.matches && n.matches(IG_CONTAINER_SELECTOR)) ||
            (n.querySelector && n.querySelector(IG_CONTAINER_SELECTOR))
          ) {
            found = true;
            break;
          }
        }
        if (found) break;
      }
      if (found) {
        clearTimeout(debounceId);
        debounceId = setTimeout(bootstrapInstagramWhenPresent, 100);
      }
    });
    try {
      igBootstrapObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    } catch (e) {
      // ignore
    }
  }

  // Start bootstrap observer and do an initial pass in case content already exists
  startIgBootstrapObserver();
  bootstrapInstagramWhenPresent();

  // Theme Editor lifecycle: re-init and cleanup
  document.addEventListener("shopify:section:load", (e) => {
    const el = e.target || e.detail?.sectionElement || e.detail?.section;
    if (
      el &&
      el.querySelector &&
      el.querySelector(".instafeed-new-layout-item")
    ) {
      setupInstagramFeedAnimations(el);
    }
  });

  document.addEventListener("shopify:section:select", (e) => {
    const el = e.target || e.detail?.sectionElement || e.detail?.section;
    if (
      el &&
      el.querySelector &&
      el.querySelector(".instafeed-new-layout-item")
    ) {
      setupInstagramFeedAnimations(el);
    }
  });

  document.addEventListener("shopify:section:unload", (e) => {
    const el = e.target || e.detail?.sectionElement || e.detail?.section;
    if (el && typeof window.cleanupInstagramAnimations === "function") {
      window.cleanupInstagramAnimations(el);
    }
  });

  // Global cleanup (optional)
  window.cleanupInstagramAnimations = function (rootEl) {
    const targets = rootEl
      ? [rootEl]
      : Array.from(
          document.querySelectorAll(
            ".instafeed-new-layout-wrapper, .instafeed-new-layout-container, [data-instagram-feed], .js-instafeed, #instafeed",
          ),
        );
    targets.forEach((c) => c._igAnimCleanup && c._igAnimCleanup());
  };

  // Header cart count badge — keep the bubble in sync with the live cart
  function setCartCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.dataset.cartCount = count;
      el.textContent = count;
    });
  }

  function pulseCartCount() {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      if (parseInt(el.dataset.cartCount, 10) > 0) {
        el.classList.remove("cart-count--pulse");
        void el.offsetWidth; // reflow so the animation can restart
        el.classList.add("cart-count--pulse");
      }
    });
  }

  function refreshCartCount(pulse) {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCartCount(cart.item_count);
        if (pulse) pulseCartCount();
      })
      .catch(function () {});
  }

  document.addEventListener("theme:cart:added", function () { refreshCartCount(true); });
  document.addEventListener("theme:cart:update", function () { refreshCartCount(false); });
  document.addEventListener("theme:cart:loaded", function () { refreshCartCount(false); });

  // Sticky header on collection/search pages.
  // Stock Palo Alto (theme.js initStickyHeader) skips its sticky-header scroll
  // handling whenever [data-collection-filters] is on the page, so the header
  // scrolls away on collection and search templates. Biggles shows the filters
  // inline rather than as a sticky bar, so there is no conflict — replicate the
  // stock headerState() body-class toggles here for those pages.
  function initCollectionStickyHeader() {
    const header = document.querySelector("[data-site-header]");
    if (
      !header ||
      !header.hasAttribute("data-header-sticky") ||
      header.dataset.position !== "fixed" ||
      !document.querySelector("[data-collection-filters]")
    ) {
      return; // theme.js already handles pages without collection filters
    }

    function headerState(e) {
      const headerHeight = parseInt(
        header.dataset.height || header.offsetHeight,
        10,
      );
      const announcement = document.querySelector(
        "[data-announcement-wrapper]",
      );
      const threshold =
        headerHeight + (announcement ? announcement.offsetHeight : 0);
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const scrollingUp = Boolean(e && e.detail && e.detail.up);

      document.body.classList.toggle("has-scrolled", scrollTop > threshold);
      document.body.classList.toggle(
        "hide-header",
        scrollingUp &&
          scrollTop < threshold + (window.stickyHeaderHeight || 0),
      );
    }

    headerState();
    document.addEventListener("theme:scroll", headerState);
  }

  initCollectionStickyHeader();

  // Mobile overlay menu: the nav drawer covers the site header while open
  // (z-index 9500 in theme.css, above the header section's 9000). The cart
  // drawer opened from the drawer's own CART link is rendered inside the
  // header section, so it can never paint above the open menu — close the
  // menu first and let theme.js open the cart drawer as usual. (The
  // drawer-bar SEARCH button gets the same treatment inside
  // initMobileMenuSearchButton.)
  function closeNavDrawer() {
    if (!document.body.classList.contains("js-drawer-open")) return;
    const closeButton = document.querySelector(
      ".drawer--nav .drawer__close-button[data-drawer-toggle]",
    );
    if (closeButton) closeButton.click();
  }

  // Capture phase: runs before theme.js's own cart-toggle handler, which may
  // stop propagation — and closing first gives the right scroll-lock order
  // (menu unlocks, cart drawer re-locks).
  document.addEventListener(
    "click",
    function (e) {
      if (
        e.target.closest(
          ".drawer--nav .drawer__header__link[data-cart-drawer-toggle]",
        )
      ) {
        closeNavDrawer();
      }
    },
    true,
  );

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
